import "./HeadingText.css";

const HeadingText = ({ textContent, isMain, externalClasses }) => {
    let styleClass = isMain ? "main" : "regular";
    styleClass = externalClasses? styleClass +` ${externalClasses}` : styleClass;
    return <p className={styleClass}>{textContent}</p>;
};

export default HeadingText;
